import { cn } from "@/lib/utils"
import React from "react"
import { Link } from "react-router-dom"
import LeftAngleImage from "../../novus/assets/images/left-angle.svg"

const Panel = ({
  backPath,
  minHeight,
  children,
}: { backPath?: string; minHeight?: boolean; children: React.ReactNode }) => {
  return (
    <>
      {!!backPath && (
        <div className="ml-4 mb-2 flex items-center">
          <Link
            to={backPath}
            className={cn(
              "text-xs text-neutral-500 flex items-center gap-1.5 p-2",
              "hover:opacity-75",
            )}
          >
            <img src={LeftAngleImage} alt="Back" />
            Back
          </Link>
        </div>
      )}
      <div
        className={cn("bg-white rounded-[40px] px-4 py-8 relative", "md:p-12", {
          "min-h-[500px]": minHeight,
        })}
      >
        {children}
      </div>
    </>
  )
}

export default Panel
